// extracted by mini-css-extract-plugin
export default {"container":"BreakoutPage_container__99cKy","title":"BreakoutPage_title__I9IGZ","gameContainer":"BreakoutPage_gameContainer__wYDyk"};